import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from './../../../../../../root-store/login-store/login.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'download-gather',
  templateUrl: './download-gather.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryDownloadGatherComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  subscription = new Subscription();

  innerContent = {
    title: '',
    cardSubtitle: 'Documents to collect',
    downloadType: 'gather',
  };

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.innerContent.title = `<span class="font-bold text-[#25508E]"> Gather these items </span> to set up <span class="font-bold text-[#25508E]"> ${user?.first_name}’s ${this.data?.path_name} </span>`;
      })
    );
  }

  previousNextDownloadEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
